ready(function(){

	const swiperGalleries = document.querySelectorAll('.swiper.type--swiperSlider');
	if (swiperGalleries.length) {		
		swiperGalleries.forEach(swiper => {
			const swiperGalleryStyles = getComputedStyle(swiper);
			const swiperGalleryGap = parseFloat(swiperGalleryStyles.getPropertyValue('--sliderGap'));
			const slider = new Swiper('.swiper', {
				slidesPerView: 'auto',
				loop: true,
				spaceBetween: swiperGalleryGap,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				centerInsufficientSlides: true,
			});
		});
	}
});